import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getToken, removeToken } from '@/utils/auth'

// 创建axios实例
axios.defaults.baseURL = process.env.VUE_APP_BASE_API // api 的 base_url
axios.defaults.timeout = 30 * 1000 // 请求超时时间
axios.defaults.withCredentials = true

// request拦截器
axios.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

    // if (store.getters.token) {
    //   // 让每个请求携带 token
    //   // ['X-Token']是一个自定义头信息键
    //   // 请根据实际情况修改一下
    // config.headers['X-Token'] = getToken()
    // }
    return config
  },
  error => {
    // 请求出现错误
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// respone拦截器
axios.interceptors.response.use(
  /**
   * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
   * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
   */
  response => {
    const res = response.data
    if (res.resultCode != 1) {
      // -1：操作异常   401：未认证未登录   403：暂无权限
      if (res.resultCode == -1 || res.resultCode == 403 || res.resultCode == 0) {
        // 提示操作异常
        Message({
          message: res.message,
          type: 'error',
          duration: 2 * 1000
        })
      } else if (res.resultCode == 401) {
        // 判断是否为注册或登录接口
        const url = response.config.url
        if (
          url.includes('/merchant/merchant/regist-merchant') ||
          url.includes('/merchant/user/login')
        ) {
          // 注册/登录接口遇到401，直接返回错误，不弹窗
          return Promise.reject(res)
        }

        // 未登录 去登陆
        removeToken()
        MessageBox.confirm('您已经登出，您可以取消以停留在此页面，或再次登录!', '确认注销', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            store.dispatch('user/resetToken').then(() => {
              Message.success('已退出登录')
              router.push('/')
              // location.reload()
            })
          })
          .catch(() => {
            console.log(1111)
          })
      } else if (res.resultCode == 0) {
        Message({
          message: res.message,
          type: 'error',
          duration: 3 * 1000
        })
      }
      return Promise.reject(res, new Error(res.message || '错误'))
    } else {
      return Promise.resolve(res)
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

const service = ({ url, method, data } = {}) => {
  var params = new URLSearchParams()
  for (const i in data) {
    params.append(i, data[i])
  }
  return new Promise((resolve, reject) => {
    const fromdata = {
      url,
      method: method || 'post'
    }
    if (method.toLowerCase() === 'get') {
      fromdata.params = params
    } else {
      fromdata.data = params
    }
    axios(fromdata)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
export default service
